export const defineIsInvalidUrlError = (error: unknown): boolean => {
  if (typeof error !== "object" || error === null) return false;

  const maybe = error as { response?: { data?: { message?: unknown } } };
  const message = maybe.response?.data?.message;
  return typeof message === "string" && message === "Invalid URL";
};
